import { createFileRoute } from '@tanstack/react-router';

import { LabelSettings } from '@/features/labels/components/label-settings';

export const Route = createFileRoute(
  '/_authenticated/$tenantId/settings/labels',
)({
  component: LabelSettings,
});
